// Strips trailing semicolons from values authored in Contentful so they can be
// safely handed to React's inline `style` prop.
export function sanitizeCssValue(value) {
  if (typeof value !== 'string') return value;

  return value.trim().replace(/;+$/, '');
}

export function sanitizeCssValues(styles = {}) {
  return Object.fromEntries(
    Object.entries(styles).map(([key, value]) => [key, sanitizeCssValue(value)])
  );
}

// Contentful serves protocol-relative asset urls.
export function getAssetUrl(asset) {
  const url = asset?.fields?.file?.url;
  if (!url) return undefined;

  return url.startsWith('//') ? `https:${url}` : url;
}

export function isVideoAsset(asset) {
  const contentType = asset?.fields?.file?.contentType;

  return Boolean(contentType?.startsWith('video'));
}

// Resolves either a plain asset or a responsive asset entry (one holding
// separate `desktop` / `tablet` / `mobile` assets), falling back through the
// other breakpoints when the preferred one is not set.
export function getResponsiveAsset(asset, { isMobile, isTablet } = {}) {
  const fields = asset?.fields;
  if (!fields) return undefined;

  if (fields.file) return asset;

  const keys = isMobile
    ? ['mobile', 'tablet', 'desktop']
    : isTablet
    ? ['tablet', 'desktop', 'mobile']
    : ['desktop', 'tablet', 'mobile'];

  for (const key of keys) {
    if (getAssetUrl(fields[key])) return fields[key];
  }

  return undefined;
}

export function getResponsiveAssetUrl(asset, viewport) {
  return getAssetUrl(getResponsiveAsset(asset, viewport));
}
